import FirestoreService from "../firestore";
import { Fuel } from "@/types/fuels/fuels.types";

interface FirestoreResponse {
  entity?: string;
  [key: string]: any;
}

export const fuelService = {
  create: async (body: Omit<Fuel, "id" | "createdAt" | "updatedAt">, issuedBy?: string) => {
    const result = (await FirestoreService.request(
      "create-fuel",
      body,
      "setup_fuels",
      issuedBy
    )) as FirestoreResponse;

    const documentId = result?.entity;
    if (!documentId) {
      throw new Error("Failed to create fuel: No ID returned");
    }
    return documentId;
  },

  edit: async (id: string, body: Partial<Fuel>, issuedBy?: string) => {
    const result = (await FirestoreService.request(
      "edit-fuel",
      { id, ...body },
      "setup_fuels",
      issuedBy
    )) as FirestoreResponse;
    return result;
  },

  archive: async (documentId: string, issuedBy?: string) => {
    return FirestoreService.request(
      "archive-fuel",
      { documentId },
      "setup_fuels",
      issuedBy
    ) as Promise<FirestoreResponse>;
  },

  restore: async (documentId: string, issuedBy?: string) => {
    return FirestoreService.request(
      "restore-fuel",
      { documentId },
      "setup_fuels",
      issuedBy
    ) as Promise<FirestoreResponse>;
  },
}; 